import {
    Table,
    TableContainer,
    Tbody,
    Td,
    Text,
    Tfoot,
    Th,
    Thead,
    Tr
} from '@chakra-ui/react'
import { storagePage } from '../../storage'
import { DataTypePayment } from '../../types'
import Card from '../../Components/Card'

export default function PaymentMethodReport() {
    const { cashboxMovements } = storagePage

    const data: DataTypePayment[] = []

    cashboxMovements.map(i => data.push(...i.dataTypePayments))

    const newData = Object.values(
        data.reduce((agg: any, typePayment) => {
            if (!agg[typePayment.name]) {
                agg[typePayment.name] = {
                    name: typePayment.name,
                    sale_amount: 0,
                    credit_amount: 0,
                    total: 0
                }
            }
            agg[typePayment.name].sale_amount += typePayment.sale_amount
            agg[typePayment.name].credit_amount += typePayment.credit_amount
            agg[typePayment.name].total += typePayment.total
            return agg
        }, {})
    )

    const totalSale = data.reduce((acc, curr) => acc + curr.sale_amount, 0)
    const totalCollect = data.reduce((acc, curr) => acc + curr.credit_amount, 0)
    const total = data.reduce((acc, curr) => acc + curr.total, 0)

    return (
        <Card direction="column" gridGap={4} overflowY="auto">
            <Text as="b" fontSize="xl" align="center" w="full">
                Formas de pago
            </Text>
            <TableContainer>
                <Table size="sm">
                    <Thead>
                        <Tr>
                            <Th>Tipo de pago</Th>
                            <Th isNumeric>Venta</Th>
                            <Th isNumeric>Recaudado</Th>
                            <Th isNumeric>Total</Th>
                        </Tr>
                    </Thead>
                    <Tbody>
                        {newData.map((typePayment: any, i) => (
                            <Tr key={i}>
                                <Td>{typePayment.name}</Td>
                                <Td isNumeric>
                                    {typePayment.sale_amount.toFixed(2)}
                                </Td>
                                <Td isNumeric>
                                    {typePayment.credit_amount.toFixed(2)}
                                </Td>
                                <Td isNumeric>
                                    {typePayment.total.toFixed(2)}
                                </Td>
                            </Tr>
                        ))}
                    </Tbody>
                    <Tfoot>
                        <Tr>
                            <Th>Total</Th>
                            <Th isNumeric>S/{totalSale.toFixed(2)}</Th>
                            <Th isNumeric>S/{totalCollect.toFixed(2)}</Th>
                            <Th isNumeric>S/{total.toFixed(2)}</Th>
                        </Tr>
                    </Tfoot>
                </Table>
            </TableContainer>
        </Card>
    )
}
